"use strict";var e={header:{"es-MX":{moreDetails:"Información"}}};exports.default=e;